import { z } from 'zod';
import { dateValueToIso } from '@/utils/dateConverter';

/**
 * Search form schema for 患者リスト(施術師毎) — /visits/visitpatient_init.
 *
 * Mirrors RA2 schedule_visit_patient.blade.php JS validation order:
 *   ① 訪問年月日開始日 required
 *   ② 訪問年月日終了日 required
 *   ③ when 施術師 radio = 指定あり, massager_id required
 *
 * The practitioner alert text differs per service type — caller interpolates
 * the label (はり・きゅう師 / マッサージ師) into the message returned here.
 */
export const visitPatientSearchSchema = z
  .object({
    visitDateFrom: z
      .string()
      .refine(v => !!v && !!dateValueToIso(v), {
        message: '【訪問年月日開始日】を入力してください',
      }),
    visitDateTo: z
      .string()
      .refine(v => !!v && !!dateValueToIso(v), {
        message: '【訪問年月日終了日】を入力してください',
      }),
    expirationDateFrom: z.string(),
    expirationDateTo: z.string(),
    insurerTypeId: z.number().int().nullable(),
    ageFrom: z.number().int().min(0).max(999).nullable(),
    ageTo: z.number().int().min(0).max(999).nullable(),
    massagerRadio: z.enum(['1', '2']),
    massagerId: z.number().int().positive().nullable(),
  })
  .superRefine((data, ctx) => {
    if (data.massagerRadio === '2' && !data.massagerId) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['massagerId'],
        // Caller substitutes 施術師 → はり・きゅう師 / マッサージ師.
        message: '施術師を選択してください',
      });
    }
  });

export type VisitPatientSearchFormValues = z.infer<typeof visitPatientSearchSchema>;
